module.exports = __webpack_public_path__ + "static/media/portugal2020-cor.250a5e65.png";